module.exports = __webpack_public_path__ + "assets/img/introduction-zh.f95212e2.png";